﻿import './style/feedbackBtn.scss';
import './style/feedbackBtn-cacp-theme.scss';
import './style/feedbackBtn-compact-theme.scss';
import './style/messageLayouts.scss';
import FAQModal from './components/faqModal/index.js';


let currentCrglFAQInstance = null;

const CrglFAQ = (props) => {
    let faqModal = null;
    let target = document.getElementById('feedback-ai-btn');
    if (!target) {
        target = document.createElement('div');
        target.id = 'feedback-ai-btn';
        document.body.appendChild(target);
    }
    faqModal = new FAQModal(props);
    
    currentCrglFAQInstance = faqModal;
    

    if (typeof window !== 'undefined') {
        window.CrglFAQInstance = faqModal;
    }
    
    target.addEventListener('click', () => {
        // 调用 openModal 方法，而不是直接操作 DOM
        faqModal.openModal();
    });
    return faqModal
}


CrglFAQ.getCrglFAQ = () => {
    return currentCrglFAQInstance || (typeof window !== 'undefined' ? window.CrglFAQInstance : null);
}

export default CrglFAQ;
